import { TranslateService } from "@ngx-translate/core";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from "shared-components";
import { RoyaltiesContextService } from "../../context/royalties-context.service";
import { RoyaltiesService } from "../../services/royalties.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-gestion-royalties",
  templateUrl: "./gestion-royalties.component.html",
})
export class GestionRoyaltiesComponent implements OnInit, OnDestroy {

  private _filters;
  public filtersVisible = true;
  public filtersForm: UntypedFormGroup;

  public pestanaActiva = 1;

  public royalties;
  public royaltiesProductor;
  public royaltiesEtiquetador;
  public unidadesMedida;
  public filterEtqApplied;
  public filterProdApplied;

  public entidadesControl;
  public paises;
  public denominaciones;
  public marcas;
  public etiquetadores;
  public productores;
  public disabledEntidadControl: Subject<boolean> = new Subject();
  public disabledPaises: Subject<boolean> = new Subject();
  public disabledDenominaciones: Subject<boolean> = new Subject();
  public disabledMarcas: Subject<boolean> = new Subject();
  public disabledEtiquetadores: Subject<boolean> = new Subject();
  public disabledProductores: Subject<boolean> = new Subject();

  public mensajes = new Array<Message>();
  public showError: boolean;
  public showWarning: boolean;

  public licenciaId;
  public userName;
  public licenciaJunta;

  public toCloseSpinner = 0;

  public totalesVisible = true;

  public orderBy: string;
  public columnId: number;
  public resetArrowsIcon = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly _router: Router,
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _royaltiesContext: RoyaltiesContextService,
    private readonly _royaltiesService: RoyaltiesService,
    private readonly _dataProvider: DataProvider,
    private readonly _sessionContext: SessionContextService,
    private readonly _translate: TranslateService
  ) {}

  ngOnInit() {
    this.filtersForm = this._fb.group({
      entidadControl: ["", Validators.required],
      pais: [{ value: "", disabled: true }],
      denominacion: [{ value: "", disabled: true }],
      marca: [{ value: "", disabled: true }],
      etiquetador: [{ value: "", disabled: true }],
      productor: [{ value: "", disabled: true }],
      asociadoMarca: [{ value: false, disabled: true }]
    });

    this.filtersForm.get("entidadControl").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((entidadControl) => {
        if (entidadControl) {
          this.getPaisesByEntidadControl(entidadControl.id);
          this.getEtiquetadoresByEntidadControl(entidadControl.id);
          this.getProductoresByEntidadControl(entidadControl.id);
        } else {
          this.disabledPaises.next(true);
          this.paises = [];
          this.filtersForm.get("pais").patchValue("");
          this.filtersForm.get("pais").disable();
          this.disabledEtiquetadores.next(true);
          this.etiquetadores = [];
          this.filtersForm.get("etiquetador").patchValue("");
          this.filtersForm.get("etiquetador").disable();
          this.disabledProductores.next(true);
          this.productores = [];
          this.filtersForm.get("productor").patchValue("");
          this.filtersForm.get("productor").disable();
        }
      });

    this.filtersForm.get("pais").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
      if (pais) {
        this.getDenominacionesByPaisEntidadControl(pais.id);
      } else {
        this.disabledDenominaciones.next(true);
        this.denominaciones = [];
        this.filtersForm.get("denominacion").patchValue("");
        this.filtersForm.get("denominacion").disable();
      }
    });

    this.filtersForm.get("denominacion").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
        if (denominacion) {
          this.getMarcasByPaisEntidadControlDeno(denominacion.id);
        } else {
          this.disabledMarcas.next(true);
          this.marcas = [];
          this.filtersForm.get("marca").patchValue("");
          this.filtersForm.get("marca").disable();
          this.filtersForm.get("asociadoMarca").patchValue(false);
          this.filtersForm.get("asociadoMarca").disable();
        }
      });

    this._royaltiesContext.gestionRoyaltiesFilters = null;

    this.getEntidadesControl();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getEntidadesControl(){
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._royaltiesService.getEntidadControlAll().toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      if (resp.length > 0) {
        this.entidadesControl = resp;
        if (this.entidadesControl && this.entidadesControl.length == 1) {
          this.filtersForm.get("entidadControl").patchValue(this.entidadesControl[0]);
          this.filtersForm.get("entidadControl").disable({onlySelf: true, emitEvent: false});
          this.disabledEntidadControl.next(true);
          this.showWarning = false;
          this.mensajes = [];
          this.getRoyalties();
        } else {
          this.showWarning = true;
          this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
        }
      }
    });
  }

  public getPaisesByEntidadControl(entidadControlId) {
    let filters = {
      entidadControlId: entidadControlId,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._royaltiesService.getPaisesByEntidadControl(filters).toPromise().finally(() => {
        this.checkCloseSpinner();
      }).then((resp) => {
        if (resp.lista.length > 0) {
          this.paises = resp.lista;
          if (this.paises.length === 1) {
            this.filtersForm.get("pais").patchValue(this.paises[0]);
            this.filtersForm.get("pais").disable({onlySelf: true, emitEvent: false});
            this.disabledPaises.next(true);
          } else {
            this.filtersForm.get("pais").enable();
            this.disabledPaises.next(false);
          }
        }
      });
  }

  public getProductoresByEntidadControl(entidadControlId){
    let filters = {
      entidadControlId: entidadControlId,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._royaltiesService.getProuctoresByEntidadControl(filters).toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      if (resp.lista.length > 0) {
        this.productores = resp.lista;
        this.filtersForm.get("productor").enable();
        this.disabledProductores.next(false);
      }
    });
  }

  public getEtiquetadoresByEntidadControl(entidadControlId){
    let filters = {
      entidadControlId: entidadControlId,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._royaltiesService.getEtiquetadoresByEntidadControl(filters).toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then((resp) => {
      if (resp.lista.length > 0) {
        this.etiquetadores = resp.lista;
        this.filtersForm.get("etiquetador").enable();
        this.disabledEtiquetadores.next(false);
      }
    });
  }

  public getDenominacionesByPaisEntidadControl(paisId) {
    let filters = {
      paisId: paisId,
      entidadControlId: this.filtersForm.get("entidadControl").value.id,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._royaltiesService.getDenominacionesByPaisEntidadControl(filters).toPromise().finally(() => {
        this.checkCloseSpinner();
      }).then((resp) => {
        if (resp.lista.length > 0) {
          this.denominaciones = resp.lista;
          if (this.denominaciones.length === 1) {
            this.filtersForm.get("denominacion").patchValue(this.denominaciones[0]);
            this.filtersForm.get("denominacion").disable({onlySelf: true, emitEvent: false});
            this.disabledDenominaciones.next(true);
          } else {
            this.filtersForm.get("denominacion").enable();
            this.disabledDenominaciones.next(false);
          }
        }
      });
  }

  public getMarcasByPaisEntidadControlDeno(denominacionId) {
    let filters = {
      paisId: this.filtersForm.get("pais").value.id,
      entidadControlId: this.filtersForm.get("entidadControl").value.id,
      denominacionId: denominacionId,
    };
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._royaltiesService.getMarcasByPaisEntidadControlDeno(filters).toPromise().finally(() => {
        this.checkCloseSpinner();
      }).then((resp) => {
        if (resp.lista.length > 0) {
          this.marcas = resp.lista;
          this.filtersForm.get("marca").enable();
          this.disabledMarcas.next(false);
          this.filtersForm.get("asociadoMarca").enable();
        }
      });
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get role() {
    return this._sessionContext.sessionUser.role;
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  public get unidadesPeso() {
    return this._dataProvider.unidadesPesoRoyalties;
  }

  public get unidadesDivisas() {
    return this._dataProvider.unidadesDivisasRoyalties;
  }

  public get unidadesSuperficie() {
    return this._dataProvider.unidadesSuperficieRoyalties;
  }

  public get unidadesNPlantas() {
    return this._dataProvider.unidadesNPlantasRoyalties;
  }

  public showRoyaltiesProductor() {
    this.pestanaActiva = 1;
  }

  public showRoyaltiesEtiquetador() {
    this.pestanaActiva = 2;
  }

  public checkValuesForm(): boolean {
    return this.filtersForm.get("entidadControl").value ||
      this.filtersForm.get("pais").value ||
      this.filtersForm.get("denominacion").value ||
      this.filtersForm.get("marca").value ||
      this.filtersForm.get("etiquetador").value ||
      this.filtersForm.get("productor").value ||
      this.filtersForm.get("asociadoMarca").value ? true : false;
  }

  public filtrar() {
    if (this.filtersForm.invalid) {
      this.mensajes = [];
      this.showError = true;
      this.mensajes.push({ class: "error", message: "global.error.required" });
    } else {
      this.applyFilters();
    }
  }

  public resetForm() {
    this.filtersForm.reset({
      entidadControl: this.filtersForm.get('entidadControl').disabled ? this.filtersForm.get('entidadControl').value : null
    });
  }

  public applyFilters() {
    this.resetArrowsIcon = true;
    this._royaltiesContext.gestionRoyaltiesFilters = {
      entidadControlId: this.filtersForm.get("entidadControl").value ? this.filtersForm.get("entidadControl").value.id : "",
      paisId: this.filtersForm.get("pais").value ? this.filtersForm.get("pais").value.id : "",
      denominacionId: this.filtersForm.get("denominacion").value ? this.filtersForm.get("denominacion").value.id : "",
      marcaId: this.filtersForm.get("asociadoMarca").value ? -1 : this.filtersForm.get("marca").value ? this.filtersForm.get("marca").value.id : "",
      etiquetadorId: this.filtersForm.get("etiquetador").value && this.pestanaActiva === 2 ? this.filtersForm.get("etiquetador").value.id : "",
      productorId: this.filtersForm.get("productor").value && this.pestanaActiva === 1 ? this.filtersForm.get("productor").value.id : ""
    };

    this.getRoyalties();
  }

  public getRoyalties() {
    if (this._royaltiesContext.gestionRoyaltiesFilters) {
      this._filters = this._royaltiesContext.gestionRoyaltiesFilters;
    } else {
      this.applyFilters();
    }
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this.mensajes = [];
    this.showError = false;
    this.getUnidadesMedida();
    this._royaltiesService.getRoyaltiesFee(this._filters).toPromise().finally(() => {
      this.resetArrowsIcon = false;
      this.checkCloseSpinner();
    }).then((resp) => {
      this.royalties = resp;
      this.royaltiesProductor = resp.lsProductor;
      this.royaltiesEtiquetador = resp.lsEtiquetador;
      this.filterEtqApplied = this._filters.etiquetadorId ? true : false;
      this.filterProdApplied = this._filters.productorId ? true : false;
    }, (error) => {
      this.showError = true;
      switch (error.error.ApiErrorCode) {
        case 6169: // RoyaltyNoAsociadasAEntidadControlPD
          this.mensajes.push({ class: 'error', message: 'gestionRoyalties.error.royaltyNoAsociadasAEntidadControlPD' });
          break;
        default:
          this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
          break;
      }
    });
  }

  public getUnidadesMedida() {
    const entidadControl = this.filtersForm.get("entidadControl").value;
    this.unidadesMedida = {
      peso: this.unidadesPeso.find(a => a.id === entidadControl.unidadMedidaId),
      divisas: this.unidadesDivisas.find(a => a.id === entidadControl.divisaId),
      superficie: this.unidadesSuperficie.find(a => a.id === entidadControl.uM_SuperficieId),
      nPlantas: this.unidadesNPlantas.find(a => a.id === entidadControl.uM_NPlantasId)
    };
  }

  public onAsociadoMarca(event: any){
    if (event.target.checked) {
      this.disabledMarcas.next(true);
      this.filtersForm.get("marca").patchValue("");
      this.filtersForm.get("marca").disable();
    } else {
      this.filtersForm.get("marca").enable();
      this.disabledMarcas.next(false);
    }
  }

  private checkCloseSpinner() {
    this.toCloseSpinner -= 1;
    if (this.toCloseSpinner === 0) {
      this._spinnerService.hideSpinner();
    }
  }

  public getIcon(prop: string) {
    let iconClass = "fa fa-sort";
    if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty === prop) {
      iconClass = this._filters.orderItems[0].orderByDescending === true ? "fa fa-sort-down" : "fa fa-sort-up";
    }
    return iconClass;
  }

  public toOrderBy(columnFilter, idColumn) {
    this.columnId = idColumn;
    if (this.royalties && this.royalties.length > 0) {
      if (this._royaltiesContext.gestionRoyaltiesFilters) {
        this._filters = this._royaltiesContext.gestionRoyaltiesFilters;
        if (!this.orderBy || this.orderBy.includes("DESC")) {
          this.orderBy = "ASC" + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: false,
            },
          ];
        } else if (this.orderBy.includes("ASC")) {
          this.orderBy = "DESC" + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: true,
            },
          ];
        }
        this.getRoyalties();
      }
    }
  }

  public exportPdfOrExcel(type, productorId, etiquetadorId) {
    if((this.pestanaActiva === 1 && this.royaltiesProductor && this.royaltiesProductor.length > 0) ||
      (this.pestanaActiva === 2 && this.royaltiesEtiquetador && this.royaltiesEtiquetador.length > 0)){
      let filters;
      if (this._royaltiesContext.gestionRoyaltiesFilters) {
        filters = {...this._royaltiesContext.gestionRoyaltiesFilters};
        filters.tipoArchivo = type === 1 ? 'Pdf' : 'Excel';
        filters.royaltyRole = this.pestanaActiva === 1 ? "Productor" : "Etiquetador";
        if(productorId && !filters.productorId) filters.productorId = productorId;
        if(etiquetadorId && !filters.etiquetadorId) filters.etiquetadorId = etiquetadorId;
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._royaltiesService.getReportRoyalty(filters).toPromise().finally(() => {
          this.checkCloseSpinner();
        }).then((resp) => {
          const downloadLink = document.createElement('a');
          downloadLink.href = (type === 1 ? 'data:application/pdf;base64,' : 'data:application/vnd.ms-excel;base64,') + resp.base64Archivo;
          downloadLink.download = resp.nombreArchivo;
          downloadLink.click();
        }, (error) => {
          this.showError = true;
          this.mensajes.push({ class: 'error', message: 'global.error.file' });
        });
      }
    } else{
      this.showError = true;
      this.mensajes.push({ class: 'error', message: 'global.error.exportNoData' });
    }
  }

  public exportPdfProductor(productorId) {
    this.exportPdfOrExcel(1, productorId, null);
  }

  public exportPdfEtiquetador(etiquetadorId) {
    this.exportPdfOrExcel(1, null, etiquetadorId);
  }

  public openDocHelp() {
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._royaltiesService.getDocHelp('Administration_Royalties.pdf').toPromise().finally(() => {
        this.checkCloseSpinner();
    }).then((resp) => {
        localStorage.setItem('base64', resp.base64Archivo);
        const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
        window.open(url, '_blank');
    });
  }
}
